<template>
  <el-row class="editor-right-inside" :class="getThemeInfo" v-if="status">
    <el-tabs v-model="activeName" type="border-card" :stretch="true" @tab-click="handleClickTab">
      <el-tab-pane label="翻译建议" name="first">
        <Suggest />
      </el-tab-pane>
    </el-tabs>
  </el-row>
</template>

<script>
import Suggest from "./modules/suggest";
import RemarksBox from "./modules/remarks";
import Dictionary from "./modules/dictionary";
import Score from './modules/score';
export default {
  name: "EditorRight",
  components: { Suggest, RemarksBox, Dictionary, Score },
  data() {
    return {
      number: 0,
      toolNumber: 0,
      activeName: 'first',
      form: {
        source: null,
        target: null,
      },
      status: true,
    }
  },
  computed: {
    /**
     * @desc 通过路由参数 type 判断进入途径
     * @return {string} 
     */
    getUrlTypeInfo() {
      let urlInfo = this.$store.getters['editor/getUrlInfo']
      if (urlInfo && urlInfo.type) {
        return urlInfo.type
      }
      return ''
    },
    /**
     * @desc 获取当前选中tab的name
     * @return {string} 
     */
    getSuggestActiveNameInfo() {
      return this.$store.getters['editor/getSuggestActiveNameInfo']
    },
    /**
     * @desc 通过当前进度编辑器的途径 ，身份type ，任务状态判断是否渲染评分tab
     * @return {boolean} 
     */
    isShowFourthTab() {
      if (this.getUrlTypeInfo !== 'school') {
        return false
      }
      let { identityType } = JSON.parse(localStorage.getItem('userInfo'))
      if (!([1, 2, 3].includes(parseInt(identityType)))) {
        return false
      }
      let fileTaskInfo = this.$store.getters['editor/getFileTaskInfo']
      let { finish } = fileTaskInfo
      if (parseInt(finish) !== 1) {
        return false
      }
      let { scoreStatus } = this.$store.getters['editor/evaluationResults']
      if (!scoreStatus) {
        return false
      }
      return true
    },
    /**
     * @desc 获取当前主题类型 返回类名
     * @return {string}
     */
    getThemeInfo() {
      let themeInfo = this.$store.getters['editor/getThemeInfo'];
      if (themeInfo === 'dark') {
        return 'dark-editor-right-inside';
      } else if (themeInfo === 'eye-protection') {
        return 'eye-protection-editor-right-inside'
      }
      return ''
    },
  },
  watch: {
    // 监听vuex存储的tab name值变化
    getSuggestActiveNameInfo(newVal) {
      this.activeName = newVal
    }
  },
  methods: {
    /**
     * @param {Object} tab 组件实例
     * @desc 切换Tab点击事件--注意组件的卸载和装载
     */
    handleClickTab(tab) {
      if (this.getSuggestActiveNameInfo === tab.name) {
        return
      }
      this.status = false;
      this.$nextTick(() => {
        this.status = true;
        if (tab.name !== "third") {
          this.$store.dispatch("editor/setthird", false);
        }
        this.$store.dispatch('editor/setEditorRightActiveName', tab.name);
      });
    }
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>